export default __webpack_public_path__ + "static/media/customers_icon.91bb5abf.svg";